<div *transloco="let t" class="business-equipment-form">
  <div [formGroup]="businessEquipmentFormGroup" id="businessEquipmentForm">
    <div class="equipment-row" formArrayName="equipments">
      <div *ngFor="let equipment of equipmentFormGroups; let i = index">
        <app-business-equipment-tuple
          [formGroup]="equipment"
          [label]="equipmentData.labels.serial"
          [index]="i"
          (removeTuple)="removeTuple($event)"
          [canRemoveTuple]="isAdmin"
          [canAddNotes]="isAdmin || isCallCenterAgent"
          [businessSummary]="businessSummary"
        ></app-business-equipment-tuple>
      </div>
    </div>
  </div>
</div>
